import fetchAPI from 'utils/fetchAPI';

export const MARKET_PROVIDERS_FETCHING = 'MARKET_PROVIDERS_FETCHING';
export const MARKET_PROVIDERS_FETCHED = 'MARKET_PROVIDERS_FETCHED';

const handleJSON = (res: any) =>
  new Promise((resolve, reject) => {
    const r = res.clone();
    res
      .json()
      .then((json: any) => resolve(json))
      .catch((e: any) => {
        if (e instanceof SyntaxError) {
          r.text()
            .then((t: any) => resolve(t))
            .catch((e: any) => reject(e));
        } else {
          reject(e);
        }
      });
  });

const handleResponse = (res: any) => {
  if (res.status === 200) {
    const contentType = res.headers.get('content-type');
    if (contentType && contentType.indexOf('application/json') !== -1) {
      return handleJSON(res);
    }
    return res.text();
  }
  throw new Error(res.status);
};

function getMarketProvidersStart() {
  return {
    type: MARKET_PROVIDERS_FETCHING,
  };
}

function getMarketProvidersComplete(data: any): DataGatePageAction {
  return {
    type: MARKET_PROVIDERS_FETCHED,
    payload: {
      data,
    },
  };
}

export const getMarketProviders = ({ q = '', page = 1 }) => (
  dispatch: Function,
  getState: Function
) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;

    dispatch(getMarketProvidersStart());
    fetchAPI({
      endpoint: `/channels/market_providers?q=${q}&page=${page}`,
      method: 'GET',
      version: '1.2',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
      .then(res => handleResponse(res))
      .then(
        json => {
          dispatch(getMarketProvidersComplete(json));
          resolve(json);
        },
        err => reject(err)
      );
  });



// WEBPACK FOOTER //
// ./app/actions/DataGatePageActionCreators.ts